export default __webpack_public_path__ + "static/media/baby-1920.6e002e0e.bmp";